// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__gilroyExtraBold_b85639', '__gilroyExtraBold_Fallback_b85639'","fontWeight":800},"className":"__className_b85639","variable":"__variable_b85639"};